<template>
    <div class="Layout">
        <div class="Layout__wrapper">
            <Header />
            <div class="container container--app">
                <router-view @start="validate">
                    <Disclaimer
                        v-if="startPage"
                        v-model="disclaimerAccepted"
                        :show-error="showError"
                    />
                    <InfoBox
                        v-else
                        class="Layout__infobox"
                    >
                        <p>View the <a href="https://life.suncorp.com.au/calculator/static/assumptions.pdf" target="_blank">Purpose, Assumptions, Methodology and Disclaimer.</a></p>
                    </InfoBox>
                </router-view>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
    import help from '@/assets/icons/help.svg';
    import Checkbox from '@/components/Checkbox.vue';
    import Disclaimer from '@/components/Disclaimer.vue';
    import Footer from '@/components/Footer.vue';
    import Header from '@/components/Header.vue';
    import InfoBox from '@/components/InfoBox.vue';
    import '@/assets/styles/spacing.scss';
    import '@/assets/styles/palette.scss';
    import '@/assets/styles/typography.scss';
    import '@/assets/styles/components/container.scss';
    import '@/assets/styles/components/button.scss';
    import * as track from '@/utilities/tracking';


    export default {
        components: {
            Checkbox,
            Disclaimer,
            Footer,
            Header,
            InfoBox
        },

        metaInfo() {
            return this.$route.fullPath.includes('life')
                ? {
                      title: 'Life Insurance Calculator | Suncorp',
                      meta: [
                          {
                              name: 'description',
                              content:
                                  "Try our life insurance calculator to get an idea of the amount of cover that may be right for you. Protect your loved ones with confidence. Calculate your cover. "
                          }
                      ]
                  }
                : {
                      title: 'Income Protection Insurance Calculator | Suncorp',
                      meta: [
                          {
                              name: 'description',
                              content:
                                  "Secure your income and protect yourself and your loved ones with confidence. Try our Income Protection Insurance calculator to estimate the coverage you may need."
                          }
                      ]
                  };
        },

        data() {
            return {
                help,
                disclaimerAccepted: false,
                showError: false
            };
        },

        computed: {
            startPage() {
                return ['IncomeCalculatorHome', 'LifeCalculatorHome'].includes(this.$route.name)
            },
            step() {
                return this.$store.state.step;
            }
        },

        mounted() {
            // Track all links throughout the app... Watch for new ones every 1000ms
            window.setInterval(() => {
                const links = Array.from(document.querySelectorAll('a'));
                links.forEach((link) => {
                    if (link.getAttribute('tracked')) return;
                    link.addEventListener('click', () => {
                        track.linkClick(link.innerText, link.href, this.$store.state.step);
                    });
                    link.setAttribute('tracked', 'true');
                });
            }, 1000);
        },
        
        watch: {
            step() {
                document.querySelector('.Header__back').focus();
            },
            '$route' () {
                document.querySelector('.Header__back').focus();
            }
        },

        methods: {
            validate(value) {
                if (this.disclaimerAccepted) {
                    this.$store.commit('reset');
                    this.$router.push(this.$router.currentRoute.path + '/' + value + '/');
                    this.disclaimerAccepted = false;
                    this.showError = false;
                } else {
                    this.showError = true
                }
            }
        }
    }
</script>

<style lang="scss">

.Layout__wrapper {
    background-color: #F5F3F1;
}

.Layout__infobox {
    margin-top: 30px;

    @media screen and (min-width: 768px) {
        margin-top: 40px;
    }
}

// TODO: Refactor Slider into a separate component

.Slider {
    padding: 1em 0;
    margin-left: 1.5rem;
    margin-right: 1.5rem;
    margin-top: 3.5em;
    margin-bottom: 4em;

    @media screen and (min-width: 768px) {
        margin: 5em 1.5rem;
        margin-top: 4.5em;
    }
}

.Slider__inputwrapper button {
    display: inline-block;
    width: auto;
    background-color: #FFCD05;
    border-radius: 2px;
    color: #000 !important;
    border: 0;
    font-size: 1.2rem;
    padding: 0.75em 1em;
    cursor: pointer;
    outline: 0;
}

@media screen and (min-width: 768px) {
    .Slider__inputwrapper button {
        padding-left: 3.5em;
        padding-right: 3.5em;
    }
}


.Slider__custominput {
    margin-top: 0;
}

.Slider__custominput label {
    display: inline-block;
    margin-right: 0.5em;
    line-height: 48px;
}

.Slider__inputwrapper {
  display: inline-block;
  vertical-align: top;
}

.Slider__inputwrapper input {
    display: inline-block;
    box-sizing: border-box;
    width: auto;
    padding: 9px 1em;
    height: 40px;
    border: 1px solid #e6e6e6;
    border-right: 0;
    font-size: 0.9em;
    vertical-align: bottom;
    color: #333;
    outline: 0;
    border-radius: 0;
    -webkit-appearance: none;
}

@media screen and (min-width: 768px) {
    .Slider__custominput {
        margin-top: 1.5em;
    }
    .Slider__inputwrapper input {
        width: 300px;
        padding-top: 14px;
        padding-bottom: 14px;
        height: 50px;
    }
}

.Slider__inputwrapper input::placeholder {
    color: #6B6B6B;
}

.Slider__inputwrapper input::-ms-clear {
    display: none;
}

.Slider__inputwrapper button {
    width: auto;
    padding: 0 0.8em;
    line-height: 40px;
    font-size: 0.9em;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}

@media screen and (min-width: 768px) {
    .Slider__inputwrapper button {
        padding: 0 1.5em;
        font-size: inherit;
        line-height: 50px;
    }
}

.Slider__inputwrapper button[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
}

.Slider__inputwrapper p {
    margin: 0.5em 0 0;
    font-size: 0.8em;
    text-align: left;
    color: #454545;
}

.note {
    font-size: 14px !important;
}
</style>
